<template>
	<el-dialog :title="form.id?'修改收货地址':'添加收货地址'" :visible.sync="dialog" width="800px" :close-on-click-modal="false">
		<div>
			<el-form :model="form" :rules="rules" ref="ruleForm" label-position="top">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="姓名" prop="receiveName">
							<el-input class="register-two-form-input" v-model="form.receiveName" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="手机号" prop="phone">
							<el-input class="register-two-form-input" v-model="form.phone" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="省市县" prop="county">
							<el-cascader style="width:100%;" :options="options" v-model="form.county"></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="详细地址" prop="detailAddress">
							<el-input class="register-two-form-input" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" v-model="form.detailAddress" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="是否为默认地址" prop="defaultStatus">
							<el-switch v-model="form.defaultStatus" :active-value="0" :inactive-value="1" active-color="rgba(233, 26, 18, 1)" inactive-color="rgba(192, 192, 192, 1)"></el-switch>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			
			<div class="address-form-button flex-center flex-midden">
				<el-button class="address-form-button-sbumit" type="primary" :loading="isSubmit" @click="submitForm('ruleForm')">确认</el-button>
				<el-button class="address-form-button-close" type="primary" :loading="false" @click="dialog = false;">取消</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import {saveAddress,getAddressById} from "@/api/user"
import {pcaTextArr} from "element-china-area-data";
export default {
	name: 'addressForm',
	data(){
		var validatePhone = (rule, value, callback) => {
			if (value === '') {
			  callback(new Error('请输入手机号'));
			} else if (!/^1\d{10}$/.test(value)) {
			  callback(new Error('请输入正确的手机号'));
			} else {
			  callback();
			}
		};
		return {
			list:[],
			dialog:false,
			options:[],
			form:{
				receiveName: "",
				phone: "",
				county:[],
				detailAddress: "",
				defaultStatus: 1
			},
			rules:{
				receiveName:[
					{ required: true, message: '请输入姓名', trigger: 'blur' },
				],
				phone: [
					{ validator: validatePhone, trigger: 'blur' }
				],
				county:[
					{ required: true, message: '请选择省市县', trigger: 'blur' },
				],
				detailAddress:[
					{ required: true, message: '请输入详细地址', trigger: 'blur' },
				]
			},
			isSubmit:false
		}
	},
	methods:{
		init(id){
			this.options = pcaTextArr;
			this.isSubmit = false;
			this.form = {
				receiveName: "",
				phone: "",
				county:[],
				detailAddress: "",
				defaultStatus: 1
			};
			this.dialog = true;
			this.$nextTick(()=>{
				this.$refs.ruleForm.resetFields();
			})
			if(id > 0){
				getAddressById({id:id}).then(res=>{
					if(res.code == 1000){
						this.form = {
							id:res.data.id,
							receiveName: res.data.receiveName,
							phone: res.data.phone,
							county:[res.data.province,res.data.city,res.data.county],
							detailAddress: res.data.detailAddress,
							defaultStatus:res.data.defaultStatus
						};
						
						
					}else{
						this.dialog = false;
						return this.$message.error(res.message);
					}
				})
			}
		},
		submitForm(formName){
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.isSubmit = true;
					saveAddress({
						...this.form,
						province:this.form.county[0],
						city:this.form.county[1],
						county:this.form.county[2]
					}).then(res=>{
						if(res.code == 1000){
							this.$message.success("操作完成");
							this.dialog = false;
							this.$emit("success");
						}else{
							this.isSubmit = false;
							return this.$message.error(res.message);
						}
					})
				} else {
					return false;
			  }
			});
		}
	}
}
</script>

<style scoped lang="scss">
	
	::v-deep .el-button--primary:focus, .el-button--primary:hover{
		background: #E91A12;
		color: #FFFFFF;
		border: 1px solid #E91A12;
	}
	.address-form-button-sbumit{
		width: 160px;
		height: 46px;
		background: #E91A12;
		border: 1px solid #E91A12;
		font-size: 16px;
		font-weight: 500;
		text-align: center;
		color: #FFFFFF;
		margin: 0px 20px;
	}
	.address-form-button-close{
		width: 160px;
		height: 46px;
		background: #fff;
		border: 1px solid #E91A12;
		font-size: 16px;
		font-weight: 500;
		text-align: center;
		color:rgba(7, 11, 19, 1);
		margin: 0px 20px;
	}
	::v-deep .el-dialog__body{
		padding: 0px 60px 40px;
	}
	::v-deep .el-dialog__header{
		text-align: center;
		padding: 30px 20px 20px;
	}
	::v-deep .el-dialog__title{
		font-size: 24px;
		line-height: 32px;
		color: #070B13;
		text-align: center;
		margin-bottom: 20px;
	}
	::v-deep .el-form-item__label{
		font-size: 16px;
		line-height: 22px;
		color: rgba(7, 11, 19, 0.6);
		&::before{
			display: none;
		}
	}
</style>